import {defineAccessControlledResource, GroupAccessRule, RestrictedGroupAccessRule} from '@igp/shared/access-control';

import {groups} from '@access-control';

export const playerLevelReportCasinoResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_Casino',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportGlobalSpinsResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_GlobalSpins',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportPlayerActivityResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_PlayerActivity',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportPlayerEcologyResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_PlayerEcology',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportPokerResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_Poker',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportPokerMttResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_PokerMtt',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportPokerNhleSdResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_PokerNhleSd',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportPokerPloResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_PokerPlo',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportShareResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_Share',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportSportsResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_Sports',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});

export const playerLevelReportBasicResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_Basic',
    rules: new RestrictedGroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup]),
});

export const playerLevelReportAllResource = defineAccessControlledResource({
    name: 'PlayerLevelReport_All',
    rules: new GroupAccessRule([groups.aalRowGroup, groups.aalRowManagersGroup, groups.adminsGroup]),
});
